import SpeakButton from "@/components/SpeakButton";
import { Link } from "react-router-dom";
import { Copy, ExternalLink, MessageCircle, ShieldCheck } from "lucide-react";
import { toast } from "sonner";
import { useT } from "@/i18n";
import { PROMPTS, WEB_TEXT } from "@/components/webdev/content";

export default function ChatGptPrompts() {
  const { lang } = useT();
  const tx = WEB_TEXT[lang];
  const copy = async (text) => {
    await navigator.clipboard.writeText(text);
    toast.success(tx.copied);
  };
  return (
    <div>
      <div className="flex flex-wrap items-center gap-2"><h3 className="font-fredoka text-xl sm:text-2xl font-bold text-blue-950">{tx.gptTitle}</h3><SpeakButton compact mascot="spark" text={tx.gptTitle} testId="ask-web-gpt" /></div>
      <p className="text-blue-900 font-semibold mt-1">{tx.gptSub}</p>
      <p className="mt-2 inline-flex items-center gap-2 bg-white/80 rounded-full px-3 py-1 text-xs font-bold text-blue-900" data-testid="web-gpt-note">
        <ShieldCheck className="w-4 h-4 text-green-600" /> {tx.gptNote}
      </p>
      <ul className="mt-4 space-y-3">
        {PROMPTS[lang].map((q, i) => (
          <li key={i} className="bg-white rounded-2xl p-3 shadow-md flex flex-col sm:flex-row sm:items-center gap-3" data-testid={`web-prompt-${i}`}>
            <p className="flex-1 font-semibold text-blue-950">"{q}"</p>
            <div className="flex gap-2 shrink-0">
              <button type="button" onClick={() => copy(q)} className="bg-sky-100 hover:bg-sky-200 rounded-full px-3 py-2 text-sm font-bold text-blue-900 inline-flex items-center gap-1" data-testid={`web-prompt-copy-${i}`}>
                <Copy className="w-4 h-4" /> {tx.copy}
              </button>
              <Link to={`/chat/spark?q=${encodeURIComponent(q)}`} className="bg-blue-600 hover:bg-blue-700 rounded-full px-3 py-2 text-sm font-bold text-white inline-flex items-center gap-1" data-testid={`web-prompt-spark-${i}`}>
                <MessageCircle className="w-4 h-4" /> {tx.askSpark}
              </Link>
            </div>
          </li>
        ))}
      </ul>
      <a href="https://chatgpt.com" data-age="13+" target="_blank" rel="noopener noreferrer" className="glossy-btn inline-flex items-center gap-2 mt-5 bg-white text-blue-900 font-bold px-6 py-3 rounded-full" data-testid="web-open-chatgpt">
        {tx.openGpt} <ExternalLink className="w-4 h-4" />
      </a>
    </div>
  );
}
